import React, { useEffect, useRef } from "react";
import { FaArrowRight } from "react-icons/fa";

export const Services = (props) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add("is-visible");
          observer.unobserve(section);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <section id="serv" ref={sectionRef}>
      <div className="container">
        <div className="serv-grid">
          <div className="serv-content">
            <span className="serv-eyebrow">
              <span className="serv-eyebrow-dot" aria-hidden="true"></span>
              Para sua empresa
            </span>
            <h2>Banking que acompanha o ritmo do seu negócio</h2>
            <p className="serv-paragraph">
              {props.data
                ? props.data.paragraph
                : "Conta digital empresarial, Pix ilimitado, maquininha, antecipação de recebíveis e folha de pagamento — tudo integrado em um só lugar."}
            </p>

            <div className="serv-cta-row">
              <a
                className="btn btn-custom serv-cta"
                href="/forujob"
                aria-label="Conhecer soluções CORE bank para empresas"
              >
                Soluções para empresas
                <FaArrowRight className="serv-cta-icon" aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="serv-visual">
            <div className="serv-image-frame">
              <div className="serv-image-halo" aria-hidden="true"></div>
              <img
                src="img/team.png"
                className="serv-image"
                alt="Equipe usando o CORE bank em rotinas empresariais"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
